import script from "./HideProduct.vue?vue&type=script&lang=ts&setup=true"
export * from "./HideProduct.vue?vue&type=script&lang=ts&setup=true"

import "./HideProduct.vue?vue&type=style&index=0&id=2c79e122&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c79e122"]])

export default __exports__